import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class GCMaterialService extends CrudService {
  constructor() {
    super('GCMaterials')
  }

  searchByModelNumber = async (modelNumber) => {
    const response = await axios.get(`${this.resource}/search-by-model-number`, {
      params: { modelNumber },
    })

    const data = response?.data?.data

    return {
      mappedDetail: data?.mappedDetail,
      allDetails: Array.isArray(data?.allDetails) ? data.allDetails : [],
    }
  }

  uploadGCMaterial = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }

  downloadGCMaterials = async () => {
    const response = await axios.get(`${this.resource}/download`, {
      responseType: 'blob',
    })

    return response
  }
}

export default GCMaterialService
